import { useMemo, useState } from 'react';
import { useAgentDashboard } from '../../../../api/agent-miner-client/agent-miner-client.hooks';
import { useGlobalStore } from '../../../../store/global-store/global-store';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import {
  useTimeAllocation,
  useTimeAllocations,
} from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { LineChart } from '../../components/line-chart/line-chart';
import type { LineItem } from '../../components/line-chart/line-chart.type';
import { buildChartData } from './main-section.helpers';

const ALL_SERIES: LineItem[] = [
  { id: 'non_agent_cycle_time', name: 'Non-Agent' },
  { id: 'agent_cycle_time', name: 'Agent' },
];

export const CycleTimeChart = () => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  const organizationId = useGlobalStore((state) => state.organization?.id);
  const portfolioId = useGlobalStore((state) => state.portfolio?.id);
  const startDate = useProcessAnalysisStore((state) => state.startDate);
  const endDate = useProcessAnalysisStore((state) => state.endDate);
  const selectedTaskType = useProcessAnalysisStore((state) => state.selectedTaskType);
  const selectedPoints = useProcessAnalysisStore((state) => state.selectedPoints);
  const agentVisibleSeries = useProcessAnalysisStore((state) => state.agentVisibleSeries);
  const timeAllocationType = useTimeAllocation();
  const timeAllocations = useTimeAllocations();

  const { data } = useAgentDashboard({
    organization_id: organizationId ?? '',
    portfolio_id: portfolioId ?? '',
    start_date: startDate,
    end_date: endDate,
    time_allocation_type: timeAllocationType,
    ...(selectedTaskType ? { task_type: selectedTaskType } : {}),
    ...(selectedPoints != null ? { points: selectedPoints } : {}),
  });

  const chartData = useMemo(
    () =>
      buildChartData({
        measures: {
          non_agent_cycle_time: data?.non_agent_cycle_time,
          agent_cycle_time: data?.agent_cycle_time,
        },
        timeAllocationType,
        timeAllocations,
      }),
    [data?.non_agent_cycle_time, data?.agent_cycle_time, timeAllocationType, timeAllocations],
  );

  const selectedItems = useMemo(
    () => ALL_SERIES.filter((series) => agentVisibleSeries[series.id] ?? true),
    [agentVisibleSeries],
  );

  return (
    <LineChart
      chartData={chartData}
      selectedItems={selectedItems}
      hoveredItem={hoveredItem}
      setHoveredItem={setHoveredItem}
      yAxisConfig={{ label: 'Days' }}
      formatValue={(value) => (value !== null && value !== undefined ? `${value} days` : 'N/A')}
    />
  );
};
